// import exampleData from "../data.json"

export interface Data {
  [propName: string]: any;
}

export function buildFetchUrl(searchParams: any, type: string) {
  const region = searchParams.region
    ? "?region=" + searchParams.region
    : "?region=de";
  const language = searchParams.language
    ? "&language=" + searchParams.language
    : "&region=de";
  const page = searchParams.page ? "&page=" + searchParams.page : "";
  const limit = searchParams.limit ? "&limit=" + searchParams.limit : "";
  const term = searchParams.term ? "&term=" + searchParams.term : "";
  let filter = "";
  searchParams.filter.forEach(
    (oneFilter: string) => (filter += "&filter[]=" + oneFilter)
  );
  return `/search/${type}${region}${language}${page}${limit}${term}${filter}`;
}
export function changeUrlParameter(url: string, params: any[]) {
  const searchParams = new URLSearchParams(url);
  params.forEach(param => {
    for (const [key, value] of Object.entries(param)) {
      let newValue:string = value ? value.toString() : ''
      if (searchParams.get(key)) {
        if (value === '') {
          searchParams.delete(key)
        } else {
          searchParams.set(key, encodeURIComponent(encodeURIComponent(newValue)))
        }
      } else {
        searchParams.append(key, encodeURIComponent(encodeURIComponent(newValue)))
      }
    }
  })
  let changedApiLink:string = decodeURIComponent(searchParams.toString())
  return changedApiLink;
}

export const fetchArtistData = async (
  apiLink:string,
  signal: AbortSignal
): Promise<Data> => {
  // delay for demo purposes
  // await new Promise((r) => setTimeout(r, 1000));
  // const url = buildFetchUrl(data.searchParams, data.type);
  // console.log('test', exampleData)
  // return exampleData
  const url = decodeURIComponent(apiLink)
  const response = await fetch(url, {signal});
  if (response.status === 200) {
    return response.json();
  } else {
    throw response.text();
  }
};
